export default "__VITE_ASSET__LSgGCRsg__"